<template>
  <v-container class="pt-0">
    <v-row align="center" justify="center" >
      <v-col cols="auto" class="pl-0 text-left">
        <BackButton />
      </v-col>
      <v-col align="center">
        <!-- 64px is the width of our back button -->
        <h1
          :class="leftAlignedTitle ? 'text-left' : 'text-center'"
          style="padding-right: 64px">
        <slot />
        </h1>
        </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BackButton from "@/components/Reusable/BackButton";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    leftAlignedTitle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BackButton,
  }
}
</script>